module.exports = __webpack_public_path__ + "img/sri-lanka.3783c520.svg";